// extracted by mini-css-extract-plugin
export default {"tab-categories":"TabCategories_tab-categories__6qt-r"};